import { TimeUnitsIds } from "./constants";

export const timeUnitsConversions = (value, unitFrom, unitTo) => {
    let newValue = 0
    if (unitFrom === TimeUnitsIds.Days && unitTo === TimeUnitsIds.Min) {
        newValue = value * 480
    }
    else if (unitFrom === TimeUnitsIds.Days && unitTo === TimeUnitsIds.Hours) {
        newValue = value * 8
    }
    else if (unitFrom === TimeUnitsIds.Hours && unitTo === TimeUnitsIds.Min) {
        newValue = value * 60
    }
    else if (unitFrom === TimeUnitsIds.Min && unitTo === TimeUnitsIds.Hours) {
        newValue = value / 60
    }
    else if (unitFrom === TimeUnitsIds.Hours && unitTo === TimeUnitsIds.Days) {
        newValue = value / 8
    }
    else if (unitFrom === TimeUnitsIds.Min && unitTo === TimeUnitsIds.Days) {
        newValue = value / 480
    }
    return newValue;
}